// Which URL (if any) the Facebook preview should build a LINK CARD for. Pure,
// so each rule is asserted without jsdom. Preview fidelity only — Facebook
// already renders the card on the published post (Scott test-posted it).
//
// RULES:
// - The FIRST link in the RESOLVED caption, which is what Facebook uses.
// - A plain feed post only: a Reel or a Story renders no link card.
// - ⚠️ Only when the post has NO media. When photos or a video are attached,
//   Facebook shows the media, not a link card, so predicting a card there would
//   misrepresent what publishes. Showing less is the safe direction.
// - Instagram and Google Business render no link card at all; they never call
//   this.

import { firstCaptionLink } from './linkify';

export function facebookLinkCardUrl(input: {
  caption: string;
  mediaCount: number;
  contentType: 'feed' | 'reel' | 'story';
}): string | null {
  if (input.contentType !== 'feed') return null;
  if (input.mediaCount > 0) return null;
  return firstCaptionLink(input.caption);
}
